export default __webpack_public_path__ + "static/media/ReportsSelectedIcon.8fde28c2.svg";